import { Quaternion, Vector3 } from 'three';
import { ActionControllerEventName, ResourcesManager, Tween, ViewerModule } from '@verybigthings/vbt-webvr-framework';
export default class DishOpeningModule extends ViewerModule {
    constructor(instruments, pointerController, level) {
        super();
        this.instruments = instruments;
        this.__inited = false;
        this.dish1Open = false;
        this.dish2Open = false;
        console.log('DishOpeningModule THIS', this);
        this.pointerController = pointerController;
        this.level = level;
    }
    init() {
        let callbackDish1;
        let callbackDish2;
        this.dish1Cap = this.instruments.dish1.getObjectByName('cap');
        this.dish2Cap = this.instruments.dish2.getObjectByName('cap');
        this.actionController.on(ActionControllerEventName.click, this.dish1Cap, callbackDish1 = () => {
            if (!this.level.interaction)
                return;
            if (this.pointerController.currentPointerObject !== this.pointerController.defaultPointerObject)
                return;
            ResourcesManager.getAudioManger().getAudio('dish_opening_sound').play();
            this.cupAnimation(this.dish1Cap, true, () => {
                this.actionController.off(ActionControllerEventName.click, this.dish1Cap, callbackDish1);
                this.dish1Open = true;
                if (this.dish1Open && this.dish2Open)
                    this.fire('both_dish_opened');
            });
        });
        this.actionController.on(ActionControllerEventName.click, this.dish2Cap, callbackDish2 = () => {
            if (!this.level.interaction)
                return;
            if (this.pointerController.currentPointerObject !== this.pointerController.defaultPointerObject)
                return;
            ResourcesManager.getAudioManger().getAudio('dish_opening_sound').play();
            this.cupAnimation(this.dish2Cap, true, () => {
                this.actionController.off(ActionControllerEventName.click, this.dish2Cap, callbackDish2);
                this.dish2Open = true;
                if (this.dish1Open && this.dish2Open)
                    this.fire('both_dish_opened');
            });
        });
    }
    initClosing() {
        let callbackDish1;
        let callbackDish2;
        this.actionController.on(ActionControllerEventName.click, this.dish1Cap, callbackDish1 = () => {
            if (!this.level.interaction)
                return;
            if (this.pointerController.currentPointerObject !== this.pointerController.defaultPointerObject)
                return;
            ResourcesManager.getAudioManger().getAudio('dish_opening_sound').play();
            this.cupAnimation(this.dish1Cap, false, () => {
                this.actionController.off(ActionControllerEventName.click, this.dish1Cap, callbackDish1);
                this.dish1Open = false;
                if (!this.dish1Open && !this.dish2Open)
                    this.fire('both_dish_closed');
            });
        });
        this.actionController.on(ActionControllerEventName.click, this.dish2Cap, callbackDish2 = () => {
            if (!this.level.interaction)
                return;
            if (this.pointerController.currentPointerObject !== this.pointerController.defaultPointerObject)
                return;
            ResourcesManager.getAudioManger().getAudio('dish_opening_sound').play();
            this.cupAnimation(this.dish2Cap, false, () => {
                this.actionController.off(ActionControllerEventName.click, this.dish2Cap, callbackDish2);
                this.dish2Open = false;
                if (!this.dish1Open && !this.dish2Open)
                    this.fire('both_dish_closed');
            });
        });
    }
    finalOpening() {
        let callbackDish1;
        this.actionController.on(ActionControllerEventName.click, this.dish1Cap, callbackDish1 = () => {
            if (!this.level.interaction)
                return;
            if (this.pointerController.currentPointerObject !== this.pointerController.defaultPointerObject)
                return;
            ResourcesManager.getAudioManger().getAudio('dish_opening_sound').play();
            this.cupAnimation(this.dish1Cap, true, () => {
                this.actionController.off(ActionControllerEventName.click, this.dish1Cap, callbackDish1);
                this.dish1Open = true;
                this.fire('final_opened');
            });
        });
    }
    cupAnimation(dishCap, open, onComplete) {
        const oldPos = dishCap.position.clone();
        const oldRotation = new Quaternion().setFromEuler(dishCap.rotation.clone());
        const newRotation = new Quaternion();
        const countRotation = () => {
            const a = dishCap.rotation.clone();
            a.x = open ? -Math.PI : 0;
            newRotation.setFromEuler(a);
        };
        countRotation();
        const tweenRotate = new Tween({ alpha: 0 }).to({ alpha: 1 }, 1000)
            .onUpdate((alpha) => {
            const newPos = oldPos.clone().lerp(new Vector3(oldPos.x, oldPos.y + (open ? -.1 : .1), oldPos.z), alpha);
            Quaternion.slerp(oldRotation, newRotation, dishCap.quaternion, alpha);
            dishCap.position.copy(newPos);
        })
            .onComplete(onComplete)
            .start();
    }
    update() {
    }
}
